"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const attributor_1 = require("../../attributor/attributor");
const store_1 = require("../../attributor/store");
const container_1 = require("./container");
const Registry = require("../../registry");
class FormatBlot extends container_1.default {
    constructor(domNode) {
        super(domNode);
        this.attributes = new store_1.default(this.domNode);
    }
    static formats(domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    }
    format(name, value) {
        let format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    }
    formats() {
        let formats = this.attributes.values();
        let format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    }
    replaceWith(name, value) {
        let replacement = super.replaceWith(name, value);
        this.attributes.copy(replacement);
        return replacement;
    }
    update(mutations, context) {
        super.update(mutations, context);
        if (mutations.some(mutation => {
            return mutation.target === this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    }
    wrap(name, value) {
        let wrapper = super.wrap(name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    }
}
exports.default = FormatBlot;
